<template>   
<div class="my-wrapper">     
<div class="side">       <SideBar />     
</div>     
<div class="main-content">       <router-view></router-view>     
</div>   
</div> </template>

<script>
import { getDictList } from '@/api/my/my';
import SideBar from './components/SideBar.vue'
export default {
  name: 'My',
  components: {
    SideBar
  },
  created() {
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.my-wrapper {
  display: flex;
  min-height: 100vh;
  background: #fff;
  border-radius: 16px 0px 0px 0px;
  .side {
    flex-shrink: 0;
    border-right: 1px solid var(--lineColor);
  }
  .main-content {
    flex-grow: 1;
    overflow: hidden;
  }
}
</style>
